import { ref } from 'vue'

// Shared state across all coverage checker instances
let referrer = ref(null)
let currentPage = ref(null);

export { referrer, currentPage }
export default { referrer, currentPage }
